<template>
  <div class="payment-note">
    <p class="note-tit">{{$t('messages.deposit.deposit5')}}</p>
    <div>
      {{$t('messages.deposit.deposit44')}}
      <span class="strong-text"> {{$t('messages.support.support37')}}50{{$t('messages.support.support38')}}</span>
      {{$t('messages.home.tip74')}}
      <br />
      {{$t('messages.deposit.deposit45')}}
      <span class="strong-text">{{$t('messages.deposit.deposit31')}}</span>
      {{$t('messages.deposit.deposit46')}}
      <br />
      {{$t('messages.deposit.deposit47')}}
      <br />
      <span class="strong-text contact">
        Teams: mrk@youmi.net | Email: mrk@youmi.net | WhatsApp: +86 18028539642
      </span>
      <contact-info></contact-info>
    </div>
  </div>
</template>

<script>
import contactInfo from '../../components/contactInfo.vue'
export default {
  components:{
    contactInfo
  },
}
</script>

<style lang="scss">
  .payment-note {
    line-height: 1.8em;
    .note-tit {
      font-weight: bold;
    }
    .strong-text {
      color: #e6a23c;
    }
    .contact {
      padding-left: 16px;
    }
  }

  @media screen and (max-width: 1100px){
    .payment-note{
      .contact{
        display: none !important;
      }
    }
  }
</style>